
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */


const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Der nächste Schweizer Lockerungsschritt wird die Verhältnisse hierzulande noch stärker den schwedischen angleichen. Die Science Task Force hält dazu in ihrem Bericht fest: «Nach dem 8. Juni (wenn Schwimmbäder, Theater, Kinos, Schulen der Sekundarstufe II, Zoos, botanische Gärten sowie Bergbahnen wieder öffnen, und wenn Ansammlungen von mehr als fünf Personen wieder erlaubt sind) werden die schweizerischen und die schwedischen Massnahmen praktisch identisch sein.»`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;